// extracted by mini-css-extract-plugin
export default {"container":"YbTiHPLh","staticContainer":"rXDaEk5O"};